import {icon} from "leaflet";
import pedestre from './img/pedestre.svg';
import raquette from './img/raquette.svg';

export const MarkerPedestre = icon({
    iconUrl: pedestre,
    iconSize: [35, 35],
    iconAnchor: [17.4, 35], // point of the icon which will correspond to marker's location
    shadowUrl: null,
  });
  export const MarkerRaquette = icon({
    iconUrl: raquette,
    iconSize: [35, 35],
    iconAnchor: [17.5, 35], // point of the icon which will correspond to marker's location
    shadowUrl: null
  });